// 封装base store

export default {
  state: {
    timezoom: localStorage.getItem('timezoom') || '', // 时区存储
    timezoomChange: '', // 时区改变的监听
    isAdmin: false, // 管理员
    erpConfig: null, // 获取ERP公共配置
    roleList: '', // 页面权限
    roleData: [], // 用户的菜单权限
    platformGroup: null,
    unreadData: [], // 未读消息通知的数据
    unreadTotal: 0, // 未读消息通知的总数
    currency: null,
    system: null,
    configureLanguage: [], // 系统配置的语种
    setLanguages: 'zh-CN', // 当前系统设置的语种，默认是中文
    updateDistributorMenu: false, // 手动更新分销商系统侧边栏菜单的标识
    updateSystemMenu: false, // 手动更新运营、供应商系统侧边栏菜单的标识
    overTimeNum: 0, // 超时未发的总数
    updatePendingCount: 0, // 记录更新待处理的标识
    helpGuide: null, // 页面帮助指引
    showSidebarMenu: false, // 侧边栏菜单展示的标识
    configurationItemInfo: {}, // 配置项的数据(存储在运营端的配置)
    supplierConfigurationItemInfo: {}, // 供应商系统配置项的数据(存储在供应商端的配置)
    pageConfig: {}, // 当前系统配置信息
    saasConfigurationItems: {}, // saas配置项
    platformOrderDetails: {}, // 平台订单详情
  },
  mutations: {
    timezoomChange(state, data) {
      state.timezoomChange = data;
    },
    isAdmin(state, data) {
      state.isAdmin = data;
    },
    erpConfig(state, data) {
      state.erpConfig = data;
    },
    roleList(state, data) {
      state.roleList = data;
    },
    roleData(state, data) {
      state.roleData = data;
    },
    platformGroup(state, data) {
      state.platformGroup = data;
    },
    unreadData(state, data) {
      state.unreadData = data;
    },
    unreadTotal(state, data) {
      state.unreadTotal = data;
    },
    currency(state, data) {
      state.currency = data;
    },
    configureLanguage(state, data) {
      state.configureLanguage = data;
    },
    setLanguages(state, data) {
      state.setLanguages = data;
    },
    updateDistributorMenu(state, data) {
      state.updateDistributorMenu = data;
    },
    overTimeNum(state, data) {
      state.overTimeNum = data;
    },
    updateSystemMenu(state, data) {
      state.updateSystemMenu = data;
    },
    updatePendingCount(state, data) {
      state.updatePendingCount = data;
    },
    helpGuide(state, data) {
      state.helpGuide = data;
    },
    showSidebarMenu(state, data) {
      state.showSidebarMenu = data;
    },
    system(state, data) {
      state.system = data;
    },
    configurationItemInfo(state, data) {
      state.configurationItemInfo = data;
    },
    supplierConfigurationItemInfo(state, data) {
      state.supplierConfigurationItemInfo = data;
    },
    pageConfig(state, data) {
      state.pageConfig = data;
    },
    saasConfigurationItems(state, data) {
      state.saasConfigurationItems = data;
    },
    platformOrderDetails(state, data) {
      state.platformOrderDetails = data;
    },
  },
  actions: {}
};
